// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 713) return "static/chunks/713-d1c92657c2c4dc64.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","326":"4c6d3999","340":"layout__client_site_chrome_ui","367":"layout__minimal"}[chunkId] || chunkId) + "." + {"146":"9e921cad7ef25a9b","298":"3c17f9a45cf5b456","326":"f78dc0430da8365b","340":"6db57770af48f679","367":"cdd02d500b3fc61d"}[chunkId] + ".js";
};